import React, { lazy } from 'react';
import logo from '../src/assets/images/navbar/Solveesy.svg';
import './App.css';
import { Container } from './components/atoms';
import { Layout, Navbar } from './components/molecules';
import Input from '../src/components/atoms/Input';
import Card from './components/atoms/Card';
import { useRoutes, RouteObject  } from 'react-router-dom';
import ScrollToTop from './hooks';
import SolveesyBlog from './pages/Blogs';
import SolveesyWhitePaper from './pages/Blogs/blog';
import BlogList from './pages/Blogs/blogs';
import SolveesyRouteBlog from './blogRoute';

const Home = lazy(() => import('./pages/HomePage/index'));
const Contact = lazy(() => import('./pages/Contactus'));
const About = lazy(() => import('./pages/About'));
const Howitwork = lazy(() => import('./pages/Howitworks'));
const Legal = lazy(() => import('./pages/Legal'));
const Datadriven = lazy(() => import('./pages/DataDriven'));
const Blogs=lazy(()=>import('./pages/Blogs'))

function App() {

          {/* <div className=' px-5'>
      <Navbar/>

      <Card className='w-fit'>hg</Card>
      </div> */}
  
  const routes: RouteObject[] = [
    {
      path: "/",
      element: <Layout />,
      children: [{ index: true, element: <Home /> }],
    },
    {
      path: "/contact",
      element: <Layout />,
      children: [{ index: true, element: <Contact /> }],
    },
    {
      path: "/about",
      element: <Layout />,
      children: [{ index: true, element: <About /> }],
    },
    {
      path: "/howitwork",
      element: <Layout />,
      children: [{ index: true, element: <Howitwork /> }],
    },
    {
      path: "/legal",
      element: <Layout />,
      children: [{ index: true, element: <Legal/> }],
    },
    {
      path: "/datadriven",
      element: <Layout />,
      children: [{ index: true, element: <Datadriven/> }],
    },
     {
  path: "/blogs",
  element: <Layout />,
  children: [
    { index: true, element: <BlogList /> },   // ✅ list page
    { path: ":id", element: <SolveesyRouteBlog /> } // ✅ dynamic blog page
  ],
}
    
  ];

  const element = useRoutes(routes);

  return (
    <>
      <ScrollToTop /> 
      <div>{element}</div>
    </>
  );
 
}

export default App;
